import axios from "../../http";
import {
  CATEGORY_LIST_REQUEST,
  CATEGORY_LIST_SUCCESS,
  CATEGORY_LIST_FAIL,
} from "../Constants/CategoryConstants";

export const listStoreCategories = (force = false) => async (dispatch, getState) => {
  const {
    categoryStoreList: { categories = [], fetchedAt },
  } = getState();

  const CATEGORY_CACHE_TTL = 1000 * 60 * 2; // 2 minutos, no 30

  const isFresh =
    !force &&
    categories.length > 0 &&
    fetchedAt &&
    Date.now() - fetchedAt < CATEGORY_CACHE_TTL;

  if (isFresh) return;

  try {
    dispatch({ type: CATEGORY_LIST_REQUEST });

    const { data } = await axios.get("/api/categories/store", {
      params: { t: Date.now() }, // evita respuesta vieja en cache
    });

    const normalizedCategories = Array.isArray(data)
      ? data
      : Array.isArray(data?.categories)
      ? data.categories
      : [];

    dispatch({
      type: CATEGORY_LIST_SUCCESS,
      payload: normalizedCategories,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_LIST_FAIL,
      payload:
        error.response && error.response.data?.message
          ? error.response.data.message
          : error.message,
    });
  }
};

